// Constants.
import Locations from './item-locations';
import Sets from './set-map';

module.exports = {
    handleItem: function(item, result, setItems) {
        // Handle if item is set
        this.handleSetItem(item, setItems);

        // First lets check if it's equipped, then it'll have
        // the location_id set.
        switch (item.location_id) {
            case Locations.character.equipped:
                return result.equipped.push(item);

            case Locations.character.belt:
                return result.belt.push(item);

            default:
                break;
        }

        // Looks like the item isn't equipped, so it has to be stored
        // in cube, stash or inventory.
        switch (item.position_id) {
            case Locations.stored.inventory:
                return result.inventory.push(item);

            case Locations.stored.cube:
                return result.cube.push(item);

            case Locations.stored.stash:
                return result.stash.push(item);

            default:
                break;
        }

        return true;
    },
    handleSetItem: function(item, setItems) {
        const setId = item.set_id;
        if (setId !== undefined) {
            if (setItems[setId] === undefined) {
                setItems[setId] = {
                    name: Sets[setId].name,
                    items: []
                }
                Sets[setId].items.forEach((itemName) =>
                    setItems[setId].items.push({name: itemName, possessed: false})
                );
            }
            const setItem = setItems[setId].items.find(setItem => setItem.name === item.full_item_name);
            setItem.possessed = true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/lib/utils.js